import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Store } from '@ngrx/store'
import { take } from 'rxjs/operators'
import { verifyResetAccount } from '@adex/store/actions/auth.actions'
import { appRoutes } from '@adex/shared/routing/routes'
import { navigate } from '@adex/store/actions/global.actions'


@Component({
  selector: 'adex-forgot-password-confirmation-container',
  templateUrl: './forgot-password-confirmation-container.component.html',
  styleUrls: [ './forgot-password-confirmation-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordConfirmationContainerComponent {

  constructor(private readonly routing: ActivatedRoute, private readonly store: Store) {
    this.routing.queryParamMap.pipe(take(1)).subscribe(params => {
      const token = params.get('token')
      if (!token) return this.store.dispatch(navigate({ commands: appRoutes.root }))
      this.store.dispatch(verifyResetAccount({ tokenDto: { token } }))
    })
  }

}
